import React from 'react'
import { Accordion, Card, Col, Row, Button } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import { useSelector } from 'react-redux'
import { countries } from '../../../../../../resources/countries.json'
import { Input } from '../../../../../library/input'
import { Select } from '../../../../../library/select'

const Index = ({singleContact, setSingleContact, setSelectedContactList}) => {

    const allContactLists = useSelector(state => state.singleList.fetchContactLists.data)
    const fetchLoading = useSelector(state => state.singleList.fetchContactLists.loading)

    const renderLoadingList = () => {
		return [{
			id: 0,
			value: "",
			title: "Henter..",
			selected: true,
			disabled: true
		}]
	}

    const renderContactLists = () => {
        const phases = [{
            id: 0,
            value: "",
            title: "Velg",
            selected: true,
            disabled: true,
        }]
		allContactLists && allContactLists.map((single, index) => {
			phases.push({
				id: index + 1,
				value: single.id,
				title: single.title,
				selected: false,
				disabled: false
			})
		})
        return phases
    }

	const renderCountries = () => {
		const items = [
			{
				id: 0,
				value: "",
				title: "Velg",
				selected: true,
				disabled: false
			}
		]
		countries.map((country, index) => {
			items.push({
				id: index + 1,
				value: country.code,
				title: country.title,
				selected: singleContact.address && singleContact.address.country === country.code ? true:false,
				disabled: false
			})
		})
		return items
	}

    return(
        <div className="contact-details-container">
			<Accordion className="person-accordion" defaultActiveKey="0">
                <Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="0">
							Velg kontaktliste <i class="fad fa-chevron-down"></i>
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="0">
						<Card.Body className="card-body">
                            <Row className="info-row">
                                <Col className="info-col">
                                    <label>Kontaktliste</label>
                                    {fetchLoading ?
                                        <Select items={renderLoadingList()}/>
                                        : 
                                        <Select onChange={(e) => setSelectedContactList(e.target.value)} items={renderContactLists()}/>
                                    }
                                </Col>
                            </Row>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="1">
							Persondetaljer <i class="fad fa-chevron-down"></i>
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="1">
						<Card.Body className="card-body">
							<Row className="info-row">
							    <Col className="info-col">
									<label>Fornavn</label>
									<Input value={singleContact.general && singleContact.general.firstName ? singleContact.general.firstName:null} onChange={(e) => setSingleContact({...singleContact, general: {...singleContact.general, firstName: e.target.value}})} placeholder="Fornavn" type="text"/>
								</Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Etternavn</label>
									<Input value={singleContact.general && singleContact.general.lastName ? singleContact.general.lastName:null} onChange={(e) => setSingleContact({...singleContact, general: {...singleContact.general, lastName: e.target.value}})} placeholder="Etternavn" type="text"/>
								</Col>
							</Row>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="2">
							Kontaktpunkter <i class="fad fa-chevron-down"></i>
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="2">
						<Card.Body className="card-body">
							<Row className="info-row">
								<Col className="info-col">
									<label>E-postadresse</label>
									<Input value={singleContact.contact && singleContact.contact.lastName ? singleContact.contact.lastName:null} onChange={(e) => setSingleContact({...singleContact, contact: {...singleContact.contact, email: e.target.value}})} placeholder="E-postadresse" type="text"/>
								</Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Telefon</label>
									<Input format="phone" value={singleContact.contact && singleContact.contact.phone ? singleContact.contact.phone:null} onChange={(e) => setSingleContact({...singleContact, contact: {...singleContact.contact, phone: e.target.value}})} placeholder="Telefon" type="text"/>
								</Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Hjemmeside</label>
								    <Input value={singleContact.contact && singleContact.contact.website ? singleContact.contact.website:null} onChange={(e) => setSingleContact({...singleContact, contact: {...singleContact.contact, website: e.target.value}})} placeholder="Hjemmeside" type="text"/>
								</Col>
							</Row>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="3">
							Bedrift <i class="fad fa-chevron-down"></i>
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="3">
						<Card.Body className="card-body">
							<Row className="info-row">
								<Col className="info-col">
									<label>Navn</label>
									<Input value={singleContact.company && singleContact.company.name ? singleContact.company.name:null} onChange={(e) => setSingleContact({...singleContact, company: {...singleContact.company, name: e.target.value}})} placeholder="Navn" type="text"/>
								</Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Stilling</label>
								    <Input value={singleContact.company && singleContact.company.position ? singleContact.company.position:null} onChange={(e) => setSingleContact({...singleContact, company: {...singleContact.company, position: e.target.value}})} placeholder="Stilling" type="text"/>
								</Col>
							</Row>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="4">
							Sosiale medier <i class="fad fa-chevron-down"></i>
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="4">
						<Card.Body className="card-body">
							<Row className="info-row">
								<Col className="info-col">
									<label>Facebook</label>
									<Input value={singleContact.social && singleContact.social.facebook ? singleContact.social.facebook:null} onChange={(e) => setSingleContact({...singleContact, social: {...singleContact.social, facebook: e.target.value}})} placeholder="Facebook" type="text"/>
							    </Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Twitter</label>
									<Input value={singleContact.social && singleContact.social.twitter ? singleContact.social.twitter:null} onChange={(e) => setSingleContact({...singleContact, social: {...singleContact.social, twitter: e.target.value}})} placeholder="Twitter" type="text"/>
								</Col>
							</Row>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="5">
							Addresse <i class="fad fa-chevron-down"></i>
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="5">
						<Card.Body className="card-body">
							<Row className="info-row">
								<Col className="info-col">
									<label>Gate</label>
									<Input value={singleContact.address && singleContact.address.street ? singleContact.address.street:null} onChange={(e) => setSingleContact({...singleContact, address: {...singleContact.address, street: e.target.value}})} placeholder="Gate" type="text"/>
								</Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Postnummer</label>
									<Input format="postal" value={singleContact.address && singleContact.address.postalCode ? singleContact.address.postalCode:null} onChange={(e) => setSingleContact({...singleContact, address: {...singleContact.address, postalCode: e.target.value}})} placeholder="Postnummer" type="text"/>
								</Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Poststed</label>
									<Input value={singleContact.address && singleContact.address.city ? singleContact.address.city:null} onChange={(e) => setSingleContact({...singleContact, address: {...singleContact.address, city: e.target.value}})} placeholder="Poststed" type="text"/>
								</Col>
							</Row>
							<Row className="info-row">
								<Col className="info-col">
									<label>Land</label>
									<Select onChange={(e) => setSingleContact({...singleContact, address: {...singleContact.address, country: e.target.value}})} items={renderCountries()}/>
								</Col>
							</Row>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
	    </div>
    )
}

export default Index